import { render, staticRenderFns } from "./KeyVisualsCMS.vue?vue&type=template&id=1fa04bc0&scoped=true"
import script from "./KeyVisualsCMS.vue?vue&type=script&lang=js"
export * from "./KeyVisualsCMS.vue?vue&type=script&lang=js"
import style0 from "./KeyVisualsCMS.vue?vue&type=style&index=0&id=1fa04bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa04bc0",
  null
  
)

export default component.exports